import { Component, OnInit } from '@angular/core';
import { DataService } from "../services/dataservice.service";
import { DateService } from "../services/dateservice.service";
import { DateModel } from "../services/date.model";

@Component({
  selector: 'app-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.css']
})
export class DatesComponent implements OnInit {

  private intro: string = '';
  public dates: DateModel[] = [];

  constructor(private dataService: DataService, private dateService: DateService) {

    this.dataService.dataServiceArrived.subscribe(
      (data) =>
      {
        this.intro = data.filter((data) => {return data.Type == 'intro-events'})[0].Content;
      }
    )
    this.dateService.dateSubject.subscribe(
      (dates: DateModel[]) => {
        this.dates = dates;
      }
    )
  }

  ngOnInit() {
    this.dataService.getContent()
    this.dateService.getDates();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/dates/dates.component.ts